import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login'),
        meta: { title: 'Login', guard: false }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('../views/ResetPassword'),
        meta: { title: 'Reset Password', guard: false }
    },
    {
        path: '/qr-scan',
        name: 'qr-scan',
        component: () => import(/* webpackChunkName: "qrScan" */ '../views/qr/Scan'),
        meta: { title: 'QR Scan', guard: false }
    },
    {
        path: '/',
        component: () => import('../views/layout/Main'),
        children: [
            {
                path: '/',
                redirect: '/dashboard'
            },
            {
                path: 'permission-error',
                name: 'permission-error',
                component: () => import('../views/PermissionError'),
                meta: { title: 'Permission Error', guard: false }
            },
            {
                path: 'auth/google',
                name: 'auth-google',
                component: () => import('../views/GoogleOAth'),
                meta: { title: 'Google OAuth', guard: false }
            },
            {
                path: 'auth/microsoft',
                name: 'auth-microsoft',
                component: () => import('../views/MicrosoftOAth'),
                meta: { title: 'Microsoft OAuth', guard: false }
            },
            {
                path: 'auth/xero',
                name: 'auth-xero',
                component: () => import('../views/XeroOAth'),
                meta: { title: 'Xero OAuth', guard: false }
            },
            {
                path: 'auth/myob',
                name: 'auth-myob',
                component: () => import('../views/MYOBOAth'),
                meta: { title: 'MYOB OAuth', guard: false }
            },
            {
                path: 'dashboard',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'dashboard',
                        path: '/',
                        component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard'),
                        meta: { title: 'Dashboard', guard: false }
                    }
                ]
            },
            {
                path: 'members',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'members',
                        path: '/',
                        component: () => import(/* webpackChunkName: "members" */ '../views/members/Members'),
                        meta: { title: 'Members', guard: false }
                    },
                    {
                        name: 'create-member',
                        path: 'create',
                        component: () => import(/* webpackChunkName: "members" */ '../views/members/Form'),
                        meta: { title: 'New Member' },
                        props: {
                            type: 'New'
                        }
                    },
                    {
                        name: 'edit-member',
                        path: ':id/edit',
                        component: () => import(/* webpackChunkName: "members" */ '../views/members/Form'),
                        meta: { title: 'Edit Member' },
                        props: (route) => ({
                            type: 'Edit',
                            id: route.params.id
                        })
                    },
                    {
                        name: 'view-member',
                        path: ':id/view',
                        component: () => import(/* webpackChunkName: "members" */ '../views/members/Member'),
                        meta: { title: 'View Member' },
                        props: (route) => ({
                            id: route.params.id
                        })
                    },
                    {
                        name: 'import-members',
                        path: 'import',
                        component: () => import(/* webpackChunkName: "members" */ '../views/ImportWizard'),
                        meta: { title: 'Import Members' },
                        props: {
                            type: 'members'
                        }
                    },
                ]
            },
            {
                path: 'submissions',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'submissions',
                        path: '/',
                        component: () => import(/* webpackChunkName: "submissions" */ '../views/submissions/Submissions'),
                        meta: { title: 'Application Management', guard: false }
                    },
                    {
                        name: 'create-submission',
                        path: 'create',
                        component: () => import(/* webpackChunkName: "submissions" */ '../views/submissions/Form'),
                        meta: { title: 'New Submission' },
                        props: {
                            type: 'New'
                        }
                    },
                    {
                        name: 'edit-submission',
                        path: ':id/edit',
                        component: () => import(/* webpackChunkName: "submissions" */ '../views/submissions/Form'),
                        meta: { title: 'Edit Submission' },
                        props: (route) => ({
                            type: 'Edit',
                            id: route.params.id
                        })
                    },
                    {
                        name: 'view-submission',
                        path: ':id/view',
                        component: () => import(/* webpackChunkName: "submissions" */ '../views/submissions/Submission'),
                        meta: { title: 'View Submission' },
                        props: (route) => ({
                            id: route.params.id
                        })
                    }
                ]
            },
            {
                path: 'supplier-processing',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'supplier-processing',
                        path: '/',
                        component: () => import(/* webpackChunkName: "supplierProcessing" */ '../views/supplier-processing/Submissions'),
                        meta: { title: 'Supplier Processing', guard: false }
                    }
                ]
            },
            {
                path: 'application-forms',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'application-forms',
                        path: '/',
                        component: () => import(/* webpackChunkName: "applicationForms" */ '../views/applicationForms/ApplicationForms'),
                        meta: { title: 'Application Forms', guard: false }
                    },
                    {
                        name: 'create-application',
                        path: 'create',
                        component: () => import(/* webpackChunkName: "applicationForms" */ '../views/applicationForms/Form'),
                        meta: { title: 'New Application Form' },
                        props: {
                            type: 'New'
                        }
                    },
                    {
                        name: 'edit-application',
                        path: ':id/edit',
                        component: () => import(/* webpackChunkName: "applicationForms" */ '../views/applicationForms/Form'),
                        meta: { title: 'Edit Application Form' },
                        props: (route) => ({
                            type: 'Edit',
                            id: route.params.id
                        })
                    },
                    {
                        name: 'view-application',
                        path: ':id/view',
                        component: () => import(/* webpackChunkName: "applicationForms" */ '../views/applicationForms/ApplicationForm'),
                        meta: { title: 'View Application Form' },
                        props: (route) => ({
                            id: route.params.id
                        })
                    },
                    {
                        name: 'order-application-form',
                        path: 'order',
                        component: () => import(/* webpackChunkName: "types" */ '../views/applicationForms/Order'),
                        meta: { title: 'Order Applications' },
                    }
                ]
            },
            {
                path: 'news-items',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'news-items',
                        path: '/',
                        component: () => import(/* webpackChunkName: "news" */ '../views/news/NewsItems'),
                        meta: { title: 'News Items', guard: false }
                    },
                    {
                        name: 'create-news-item',
                        path: 'create',
                        component: () => import(/* webpackChunkName: "news" */ '../views/news/Form'),
                        meta: { title: 'New News Item' },
                        props: {
                            type: 'New'
                        }
                    },
                    {
                        name: 'edit-news-item',
                        path: ':id/edit',
                        component: () => import(/* webpackChunkName: "news" */ '../views/news/Form'),
                        meta: { title: 'Edit News Item' },
                        props: (route) => ({
                            type: 'Edit',
                            id: route.params.id
                        })
                    },
                    {
                        name: 'view-news-item',
                        path: ':id/view',
                        component: () => import(/* webpackChunkName: "news" */ '../views/news/NewsItem'),
                        meta: { title: 'View News Item' },
                        props: (route) => ({
                            id: route.params.id
                        })
                    }
                ]
            },
            {
                path: 'communications',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'communications',
                        path: '/',
                        component: () => import(/* webpackChunkName: "communications" */ '../views/communications/Communications'),
                        meta: { title: 'Communications', guard: false }
                    },
                    {
                        name: 'create-communication',
                        path: 'create',
                        component: () => import(/* webpackChunkName: "communications" */ '../views/communications/Form'),
                        meta: { title: 'New Communication' },
                        props: {
                            type: 'New'
                        }
                    },
                    {
                        name: 'edit-communication',
                        path: ':id/edit',
                        component: () => import(/* webpackChunkName: "communications" */ '../views/communications/Form'),
                        meta: { title: 'Edit Communication' },
                        props: (route) => ({
                            type: 'Edit',
                            id: route.params.id
                        })
                    },
                    {
                        name: 'view-communication',
                        path: ':id/view',
                        component: () => import(/* webpackChunkName: "communications" */ '../views/communications/Communication'),
                        meta: { title: 'View Communication' },
                        props: (route) => ({
                            id: route.params.id
                        })
                    }
                ]
            },
            {
                path: 'tasks',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'tasks',
                        path: '/',
                        component: () => import(/* webpackChunkName: "tasks" */ '../views/tasks/Tasks'),
                        meta: { title: 'Tasks', guard: false }
                    },
                    {
                        name: 'create-task',
                        path: 'create',
                        component: () => import(/* webpackChunkName: "tasks" */ '../views/tasks/Form'),
                        meta: { title: 'New Task' },
                        props: {
                            type: 'New'
                        }
                    },
                    {
                        name: 'edit-task',
                        path: ':id/edit',
                        component: () => import(/* webpackChunkName: "tasks" */ '../views/tasks/Form'),
                        meta: { title: 'Edit Task' },
                        props: (route) => ({
                            type: 'Edit',
                            id: route.params.id
                        })
                    },
                    {
                        name: 'view-task',
                        path: ':id/view',
                        component: () => import(/* webpackChunkName: "tasks" */ '../views/tasks/Task'),
                        meta: { title: 'View Task' },
                        props: (route) => ({
                            id: route.params.id
                        })
                    }
                ]
            },
            {
                path: 'configuration',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        path: '/',
                        redirect: '/dashboard'
                    },
                    {
                        path: 'suppliers',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'suppliers',
                                path: '/',
                                component: () => import(/* webpackChunkName: "suppliers" */ '../views/suppliers/Suppliers'),
                                meta: { title: 'Suppliers', guard: false }
                            },
                            {
                                name: 'create-supplier',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "suppliers" */ '../views/suppliers/Form'),
                                meta: { title: 'New Supplier' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-supplier',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "suppliers" */ '../views/suppliers/Form'),
                                meta: { title: 'Edit Supplier' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            },
                            {
                                name: 'view-supplier',
                                path: ':id/view',
                                component: () => import(/* webpackChunkName: "suppliers" */ '../views/suppliers/Supplier'),
                                meta: { title: 'View Supplier' },
                                props: (route) => ({
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: 'users',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'users',
                                path: '/',
                                component: () => import(/* webpackChunkName: "users" */ '../views/configuration/users/Users'),
                                meta: { title: 'Users', guard: false }
                            },
                            {
                                name: 'create-user',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "users" */ '../views/configuration/users/Form'),
                                meta: { title: 'New User' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-user',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "users" */ '../views/configuration/users/Form'),
                                meta: { title: 'Edit User' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            },
                            {
                                name: 'view-user',
                                path: ':id/view',
                                component: () => import(/* webpackChunkName: "users" */ '../views/configuration/users/User'),
                                meta: { title: 'View User' },
                                props: (route) => ({
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: 'groups',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'groups',
                                path: '/',
                                component: () => import(/* webpackChunkName: "groups" */ '../views/configuration/groups/Groups'),
                                meta: { title: 'Groups', guard: false }
                            },
                            {
                                name: 'create-group',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "groups" */ '../views/configuration/groups/Form'),
                                meta: { title: 'New Group' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-group',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "groups" */ '../views/configuration/groups/Form'),
                                meta: { title: 'Edit Group' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: 'permissions',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'permissions',
                                path: '/',
                                component: () => import(/* webpackChunkName: "permissions" */ '../views/configuration/permissions/Permissions'),
                                meta: { title: 'Permissions', guard: false }
                            },
                            {
                                name: 'create-permission',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "permissions" */ '../views/configuration/permissions/Form'),
                                meta: { title: 'New Permission' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-permission',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "permissions" */ '../views/configuration/permissions/Form'),
                                meta: { title: 'Edit Permission' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: 'sections',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'sections',
                                path: '/',
                                component: () => import(/* webpackChunkName: "sections" */ '../views/configuration/sections/Sections'),
                                meta: { title: 'Sections', guard: false }
                            },
                            {
                                name: 'create-section',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "sections" */ '../views/configuration/sections/Form'),
                                meta: { title: 'New Section' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-section',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "sections" */ '../views/configuration/sections/Form'),
                                meta: { title: 'Edit Section' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: 'types',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'types',
                                path: '/',
                                component: () => import(/* webpackChunkName: "types" */ '../views/configuration/types/Types'),
                                meta: { title: 'Types', guard: false }
                            },
                            {
                                name: 'create-type-option',
                                path: 'option/create',
                                component: () => import(/* webpackChunkName: "types" */ '../views/configuration/types/OptionForm'),
                                meta: { title: 'New Option' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-type-option',
                                path: 'option/:id/edit',
                                component: () => import(/* webpackChunkName: "types" */ '../views/configuration/types/OptionForm'),
                                meta: { title: 'Edit Option' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            },
                            {
                                name: 'edit-type',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "types" */ '../views/configuration/types/OptionForm'),
                                meta: { title: 'Edit Option' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            },
                            {
                                name: 'create-type-group',
                                path: 'group/create',
                                component: () => import(/* webpackChunkName: "types" */ '../views/configuration/types/GroupForm'),
                                meta: { title: 'New Group' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'order-type',
                                path: 'order',
                                component: () => import(/* webpackChunkName: "types" */ '../views/configuration/types/Order'),
                                meta: { title: 'Order Type' },
                                // props: (route) => ({
                                //     type: 'Order'
                                // })
                            },
                        ]
                    },
                    {
                        path: 'forms',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'forms',
                                path: '/',
                                component: () => import(/* webpackChunkName: "forms" */ '../views/configuration/forms/Forms'),
                                meta: { title: 'Forms', guard: false }
                            },
                            {
                                name: 'create-form',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "forms" */ '../views/configuration/forms/AddEditForm'),
                                meta: { title: 'New Form' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-form',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "forms" */ '../views/configuration/forms/AddEditForm'),
                                meta: { title: 'Edit Form' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            },
                            {
                                name: 'view-form',
                                path: ':id/view',
                                component: () => import(/* webpackChunkName: "forms" */ '../views/configuration/forms/Form'),
                                meta: { title: 'View Form' },
                                props: (route) => ({
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: 'templates',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'templates',
                                path: '',
                                component: () => import(/* webpackChunkName: "templates" */ '../views/configuration/templates/Templates'),
                                meta: { title: 'Templates', guard: false }
                            },
                            {
                                name: 'create-template',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "templates" */ '../views/configuration/templates/Form'),
                                meta: { title: 'New Template' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-template',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "templates" */ '../views/configuration/templates/Form'),
                                meta: { title: 'Edit Template' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: 'custom-fields',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'custom-fields',
                                path: '/',
                                component: () => import(/* webpackChunkName: "custom-fields" */ '../views/configuration/custom-fields/CustomFields'),
                                meta: { title: 'Custom Fields', guard: false }
                            },
                            {
                                name: 'create-custom-field',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "custom-fields" */ '../views/configuration/custom-fields/Form'),
                                meta: { title: 'New Custom Field' },
                                props: {
                                    type: 'New'
                                }
                            },
                            {
                                name: 'edit-custom-field',
                                path: ':id/edit',
                                component: () => import(/* webpackChunkName: "custom-fields" */ '../views/configuration/custom-fields/Form'),
                                meta: { title: 'Edit Custom Field' },
                                props: (route) => ({
                                    type: 'Edit',
                                    id: route.params.id
                                })
                            },
                            {
                                name: 'order-custom-fields',
                                path: 'order',
                                component: () => import(/* webpackChunkName: "custom-fields" */ '../views/configuration/custom-fields/Order'),
                                meta: { title: 'Order Custom Fields' },
                            }
                        ]
                    },
                    {
                        path: 'sms-credits',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'sms-credits',
                                path: '',
                                component: () => import('../views/configuration/SmsCredits.vue'),
                                meta: { title: 'SMS Credits', guard: false }
                            }
                        ]
                    },
                    {
                        path: 'settings',
                        component: () => import('../views/layout/SubRoot'),
                        children: [
                            {
                                name: 'settings',
                                path: '',
                                component: () => import('../views/configuration/Settings.vue'),
                                meta: { title: 'Settings', guard: false }
                            }
                        ]
                    },
                ]
            },
            {
                path: 'logs',
                component: () => import('../views/layout/SubRoot'),
                children: [
                    {
                        name: 'logs',
                        path: '/',
                        component: () => import(/* webpackChunkName: "logs" */ '../views/Logs'),
                        meta: { title: 'Logs', guard: false }
                    }
                ]
            },
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
